//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost } from '../../../../../axios/axios.js'
import { EventBus } from '../../../../../EventBus/EventBus.js'
import { mapGetters } from 'vuex'

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    selectedWorkAreaIncoming: {
      type: String,
      default: null
    },
    selectedRequestsIds: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      workAreas: [],
      selectedWorkArea: null,
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      getWorkAreas: 'getWorkAreas'
    })
  },
  watch: {
    opened: function (result) {
      if (this.selectedWorkAreaIncoming) {
        this.selectedWorkArea = this.selectedWorkAreaIncoming
      } else {
        this.selectedWorkArea = null
      }

      this.workAreas = this.getWorkAreas
      for (let i = 0; i < this.workAreas.length; i++) {
        this.workAreas[i].id = this.workAreas[i].key
      }

      for (let i = 0; i < this.selectedRequestsIds.length; i++) {
        this.getRequestWorkAreas(this.selectedRequestsIds[i], i)
      }
    }
  },
  methods: {
    onSave: function () {
      this.loading = true
      const bodyFormData = new FormData()

      bodyFormData.set('id', this.selectedRequestsIds.join(','))
      bodyFormData.set('workArea', this.selectedWorkArea)

      axiosPost({
        url: '/service/delta/request/redirectToWorkArea',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Успешный перевод заявок в отдел',
            progress: true,
            timeout: 3000
          })

          EventBus.$emit('update-request', { savePage: true, saveScroll: true })
          EventBus.$emit('update-request-popup', {})
          this.onSuccess()
        },
        onFailure: 'Ошибка перевода заявок в отдел',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onSuccess: function () {
      this.$emit('success')
    },
    onClose: function () {
      this.$emit('close')
    },
    getRequestWorkAreas: function (requestId, i) {
      this.loading = true
      axiosGet({
        url: '/service/delta/request/getRequest?id=' + requestId,
        onSuccess: (response) => {
          const request = response.data.result
          if (request.serviceObject && request.serviceObject.workAreas && request.serviceObject.workAreas.length) {
            let workAreas = []
            for (let i = 0; i < request.serviceObject.workAreas.length; i++) {
              workAreas = [...request.serviceObject.workAreas[i].availableRedirections, ...workAreas]
            }

            this.workAreas = this.workAreas.filter(workArea => {
              return workAreas.filter(e => e.id === workArea.id).length > 0
            })
          }
        },
        onFailure: 'Ошибка загрузки информации по заявке',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

